import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ArrowRightIcon from '@ingka/ssr-icon/paths/arrow-right';
import Button from '@ingka/button';
import QrTypeForm from './type-of-qr';
import TargetForm from './target';

const CreateCodeSteps: React.FC = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = React.useState<string | null>(null);
  const [selectedTarget, setSelectedTarget] = React.useState<string | null>(
    null
  );
  const isFreeTextSelected = selectedType === 'freetext';

  React.useEffect(() => {
    if (isFreeTextSelected && selectedTarget === 'customer') {
      setSelectedTarget('coworker');
      setValue('targetGroup', 'coworker');
    }
  }, [isFreeTextSelected, selectedTarget, setValue]);

  const handleNextButton = () => {
    setValue('qrType', selectedType);
    setValue('targetGroup', selectedTarget);

    if (selectedType === 'freetext') {
      navigate('/create-free-text-code');
    } else {
      navigate('/create-code');
    }
  };

  return (
    <div>
      <QrTypeForm onSelect={setSelectedType} selected={selectedType} />
      <TargetForm
        onSelect={setSelectedTarget}
        selected={selectedTarget}
        disable={isFreeTextSelected}
      />
      <div className="flex justify-end mt-6">
        <Button
          iconPosition="trailing"
          text={t('label.next')}
          type="emphasised"
          ssrIcon={ArrowRightIcon}
          className="w-full sm:w-80"
          disabled={!selectedType || !selectedTarget}
          onClick={handleNextButton}
        />
      </div>
    </div>
  );
};

export default CreateCodeSteps;
